import { useTheme } from '@mui/material/styles';
import { getVizTooltipStyles } from '../viz.styles';

export const useVizChartTheme = () => {
  const theme = useTheme();
  const { palette, typography, shape, spacing } = theme;

  return {
    tooltipStyles: getVizTooltipStyles(theme),
    axisFontSize: typography.caption.fontSize,
    endLabelFontSize: typography.micro1.fontSize,
    axisColor: palette.text.tertiary,
    endLabelColor: palette.text.primary,
    gridColor: palette.divider,
    seriesColors: palette.custom.chart.series,
    seriesOpacities: palette.custom.chart.seriesOpacities,
    lineGradient: palette.custom.chart.lineGradient,
    sliceCornerRadius: shape.borderRadiusSm,
    dotRadius: shape.borderRadiusFull,
    toPx: (units: number) => Number(spacing(units).replace('px', '')),
  };
};
